import { lazy } from 'react'
import type { RouteObject } from 'react-router-dom'

const JurisdictionHubPage = lazy(() =>
  import('../pages/jurisdiction').then((m) => ({ default: m.JurisdictionHubPage }))
)
const JurisdictionPacksPage = lazy(() =>
  import('../pages/jurisdiction').then((m) => ({ default: m.JurisdictionPacksPage }))
)
const PackRequirementsPage = lazy(() =>
  import('../pages/jurisdiction').then((m) => ({ default: m.PackRequirementsPage }))
)
const ScopingPage = lazy(() =>
  import('../pages/jurisdiction').then((m) => ({ default: m.ScopingPage }))
)
const SovereigntyDDQPage = lazy(() =>
  import('../pages/jurisdiction').then((m) => ({ default: m.SovereigntyDDQPage }))
)

export const jurisdictionRoutes: RouteObject[] = [
  {
    path: '/jurisdiction',
    children: [
      { index: true, element: <JurisdictionHubPage /> },
      { path: 'packs', element: <JurisdictionPacksPage /> },
      { path: 'packs/:packKey', element: <PackRequirementsPage /> },
      { path: 'scoping', element: <ScopingPage /> },
      { path: 'sovereignty-ddq', element: <SovereigntyDDQPage /> },
    ],
  },
]
